// Shared helper functions for course cards
// Re-export locale-aware formatters from shared utils
export {
  formatDays,
  formatTimeET as formatTime,
  formatCourseDate as formatDate,
} from '../../utils/dateFormatter';

// Legacy alias for backward compatibility
export { formatDays as koreanToEnglishDays } from '../../utils/dateFormatter';

// Format fee to "$X.XX" or null if zero/missing
export const formatFee = (fee) => {
  if (!fee || parseFloat(fee) === 0) return null;
  return `$${parseFloat(fee).toFixed(2)}`;
};

// Calculate total fee from course
export const calculateTotalFee = (course) => {
  return (parseFloat(course.tuition_fee) || 0) +
         (parseFloat(course.textbook_fee) || 0) +
         (parseFloat(course.exam_fee) || 0);
};

// Check if course start date has passed
export const isStartDatePassed = (startDate) => {
  if (!startDate) return false;
  const dateOnly = startDate.split('T')[0];
  const [year, month, day] = dateOnly.split('-').map(Number);
  if (!year || !month || !day) return false;
  const courseStartDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return courseStartDate <= today;
};
